<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о заявителе, являющимся заинтересованным лицом
        </div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicant"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.subjects.applicantRightholder">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о заявителе, являющимся правообладателем объекта недвижимости
          или лицом, в пользу которого зарегистрированы ограничения или
          обременения в отношении объекта недвижимости
        </div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicantRightholder"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.egrnConfirmStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Прошу удостоверить факт наличия в Едином государственном реестре
          недвижимости сведений о фамилии, об имени, отчестве и о дате рождения
          гражданина, являющегося правообладателем объекта недвижимости или
          лицом, в пользу которого зарегистрированы ограничения права или
          обременения объекта недвижимости, содержащихся в выписке из Единого
          государственного реестра недвижимости
        </div>
        <div>
          <Block
            :data="statement.egrnConfirmStep3"
            :field-group="FieldGroup.EGRN_CONFIRM_DETAILS"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.egrnConfirmStep4">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Доказательства, подтверждающие наличие обстоятельств, достаточных для
          получения выписки
        </div>
        <div
          class="form-base__title preview break"
          v-if="statement.egrnConfirmStep4.evidenceDocType"
        >
          Основание получения сведений, содержащихся в Едином государственном
          реестре недвижимости
        </div>
        <div>
          <Block
            :data="statement.egrnConfirmStep4"
            :field-group="FieldGroup.EVIDENCE_DOC_TYPE"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.egrnConfirmStep5">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>
        <div>
          <StepRequisites
            :data="statement.egrnConfirmStep5"
            :statement-type="StatementType.EGRN_CONFIRM"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>
        <div>
          <StepSign :data="statement.locationStep" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Block from '@/components/elements/statement/FullStatementView/elements/Block';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';
import { FieldGroup } from '@/utils/fullStatementView';

export default {
  name: 'EgrnConfirm',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    Subject,
    StepSign,
    Block,
    StepRequisites,
  },
  data: () => ({
    StatementType,
    FieldGroup,
  }),
};
</script>

<style scoped></style>
